import LazyVideo from "@/components/LazyVideo";

const SketchShowcaseSection = () => (
  <LazyVideo
    src="/Thinking_in_a_line_palyer_02.mp4"
    className="relative w-full overflow-hidden border-y border-white"
    style={{ aspectRatio: "4/1" }}
  />
);

export default SketchShowcaseSection;
